module.exports = __webpack_public_path__ + "img/watchpost64_ua.2e10f91c.webp";